import imageCompression from "browser-image-compression";
import uuid from "react-native-uuid";
import { context } from "../context";
import { AuthenticationInstance } from "./authenticationClass";

class ImageClass {
  private BASEURL: string | undefined;
  private PUBLIC_ASSETS_URL: string | undefined;

  constructor() {
    this.BASEURL = context.apiEndpoint || "http://localhost:3000";
    this.PUBLIC_ASSETS_URL = context.publicAssetsBaseUrl || "https://assets.dev.canna42.com";
  }

  public async compressImage(file: any, isAvatar: boolean = false, isExperience: boolean = false) {
    if (isExperience) {
      return file;
    }

    const options = {
      maxSizeMB: 1, // Adjust the max size as needed
      maxWidthOrHeight: isAvatar ? 500 : 630, // Adjust the max width/height as needed
      useWebWorker: true,
    };

    console.log("options: ", options);

    try {
      const compressedFile = await imageCompression(file, options);

      console.log("compressedFile instanceof Blob", compressedFile); // true
      return compressedFile;
    } catch (error) {
      console.error("Error compressing the image: ", error);
      throw error;
    }
  }

  public async uploadImageToS3(
    file: any,
    category: string,
    itemName: string,
    isAvatar?: boolean,
    isExperience?: boolean,
  ) {
    try {
      // Compress the image
      const compressedFile = await this.compressImage(file, isAvatar, isExperience);

      const fileName = `${uuid.v4()}-${compressedFile.name}`;
      const fileKey = `${category}/${itemName}/${fileName}`;

      const authUser = await AuthenticationInstance.getCurrentSession();

      if (!authUser) {
        return;
      }

      const jwtToken = authUser.token;

      console.log("uploading the following: ", compressedFile, fileKey);

      const generatePresignedUrlResponse = await fetch(`${this.BASEURL}/images/generate-presigned-url`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: jwtToken,
        },
        body: JSON.stringify({
          key: fileKey,
          ContentType: compressedFile.type,
        }),
      });

      if (!generatePresignedUrlResponse.ok) {
        throw new Error("Unable to get presigned URL for image upload.");
      }

      const { presignedUrl } = await generatePresignedUrlResponse.json();

      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
        },
        body: compressedFile,
      });

      if (!uploadResponse.ok) {
        throw new Error("Failed to upload image to S3.");
      }

      console.log("upload response: ", uploadResponse);
      console.log("filekey: ", `${this.PUBLIC_ASSETS_URL}/${fileKey}`);

      return {
        fileKey,
        uploadResponse,
      }; // Return the S3 key of the uploaded file
    } catch (error) {
      if (error instanceof TypeError) {
        console.error("Network error: ", error.message);
      } else {
        console.error("Error uploading image to S3: ", error);
      }
      throw error;
    }
  }

  public async submitImageDetails(key: string, itemId: string, itemType: string) {
    const authUser = await AuthenticationInstance.getCurrentSession();

    if (!authUser) {
      return;
    }

    const jwtToken = authUser.token;

    const response = await fetch(`${this.BASEURL}/images/save-image`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwtToken,
      },
      body: JSON.stringify({
        key,
        itemId,
        itemType,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to submit image details.");
    }

    return await response.json(); // Return the server's response
  }
}

const ImageInstance = new ImageClass();

export { ImageInstance };
